import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

function AdminResetPassword() {
    const { token } = useParams();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [verifying, setVerifying] = useState(true);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [tokenError, setTokenError] = useState('');
    const [username, setUsername] = useState('');

    useEffect(() => {
        const verifyToken = async () => {
            try {
                const res = await fetch(`/api/auth/admin/verify-reset-token/${token}`);
                const data = await res.json();

                if (!res.ok) {
                    setTokenError(data.error || 'Ungueltiger Link');
                } else {
                    setUsername(data.data?.username || '');
                }
            } catch (err) {
                setTokenError('Ein Fehler ist aufgetreten');
            }
            setVerifying(false);
        };

        verifyToken();
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Die Passwoerter stimmen nicht ueberein');
            return;
        }
        if (password.length < 8) {
            setError('Das Passwort muss mindestens 8 Zeichen haben');
            return;
        }

        setLoading(true);
        try {
            const res = await fetch('/api/auth/admin/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, new_password: password })
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.error || 'Ein Fehler ist aufgetreten');
            }

            setSuccess(true);
        } catch (err) {
            setError(err.message);
        }
        setLoading(false);
    };

    if (verifying) {
        return (
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <div className="card mt-5">
                        <div className="card-body text-center p-5">
                            <div className="spinner-border text-primary mb-3" role="status">
                                <span className="visually-hidden">Laden...</span>
                            </div>
                            <p className="text-muted">Link wird ueberprueft...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (tokenError) {
        return (
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <div className="card mt-5">
                        <div className="card-body text-center p-5">
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>❌</div>
                            <h4 className="card-title mb-3">Link ungueltig</h4>
                            <p className="text-muted mb-4">{tokenError}</p>
                            <p className="text-muted small mb-4">
                                Der Link ist moeglicherweise abgelaufen oder wurde bereits verwendet.
                            </p>
                            <Link to="/admin-passwort-vergessen" className="btn btn-primary">
                                Neuen Link anfordern
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (success) {
        return (
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <div className="card mt-5">
                        <div className="card-body text-center p-5">
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
                            <h4 className="card-title mb-3">Passwort geaendert!</h4>
                            <p className="text-muted mb-4">
                                Dein Admin-Passwort wurde erfolgreich gesetzt. Du kannst dich jetzt anmelden.
                            </p>
                            <Link to="/login" className="btn btn-primary">
                                Zum Login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
                <div className="card mt-5">
                    <div className="card-body">
                        <h4 className="card-title mb-4">Neues Admin-Passwort</h4>
                        {username && (
                            <p className="text-muted mb-4">
                                Konto: <strong>{username}</strong>
                            </p>
                        )}

                        {error && <div className="alert alert-danger">{error}</div>}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Neues Passwort</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    autoFocus
                                    minLength={8}
                                    placeholder="Mindestens 8 Zeichen"
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Passwort bestaetigen</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    minLength={8}
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Speichern...
                                    </>
                                ) : (
                                    'Passwort speichern'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminResetPassword;
